export default {
  yes: 'Yes',
  no: 'No',
  footer: {
    copyright: 'Copyright © Vue App {year}',
  },
}
